module.exports = __webpack_public_path__ + "static/media/Tupe1.b99024c0.webp";